import { FolderType } from "./Folder.dto";
import { FolderSharingRole, FolderSharingType } from "./FolderSharing.dto";
import { LoLang } from "../common/common.types";

export function ReadableFolderSharingType(role: FolderSharingType, lang?: LoLang | undefined, defaultVal = "-"): string {
  switch (role) {
    case FolderSharingType.Member:
      return lang === "KO" ? "Member" : "Member";
    case FolderSharingType.External:
      return lang === "KO" ? "External" : "External";
    default:
      return status || defaultVal;
  }
}

export function ReadableFolderSharingRole(
  req: { role: FolderSharingRole; folderType?: FolderType },
  lang?: LoLang,
  defaultVal = "-"
): string {
  const { role, folderType } = req;

  switch (role) {
    case FolderSharingRole.None:
      return lang === "KO" ? "접근 권한 없음" : "No Access";
    case FolderSharingRole.OnlineViewer:
      return lang === "KO" ? "뷰어 (Online)" : "Viewer (Online)";
    case FolderSharingRole.Viewer:
      return lang === "KO" ? "뷰어" : "Viewer";
    case FolderSharingRole.OnlineContributor:
      return lang === "KO" ? "편집자 (Online)" : "Contributor (Online)";
    case FolderSharingRole.Contributor:
      return lang === "KO" ? "편집자" : "Contributor";
    case FolderSharingRole.Manager:
      if (folderType === FolderType.ECONSENT) {
        return lang === "KO" ? "접근 권한 있음" : "Access";
      }

      return lang === "KO" ? "관리자" : "Manager";
    case FolderSharingRole.Owner:
      /** TODO: econsnet의 경우 owner 개념 삭제 */
      if (folderType === FolderType.ECONSENT) {
        return lang === "KO" ? "접근 권한 있음" : "Access";
      }

      return lang === "KO" ? "소유자" : "Owner";
    case FolderSharingRole.Admin:
      if (folderType === FolderType.ECONSENT) {
        return lang === "KO" ? "접근 권한 있음" : "Access";
      }

      return lang === "KO" ? "Organization 관리자" : "Organization Admin";
    default:
      return status || defaultVal;
  }
}
